var _classCallCheck = require("/opt/build/repo/web/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/opt/build/repo/web/node_modules/@babel/runtime/helpers/createClass");

var _get = require("/opt/build/repo/web/node_modules/@babel/runtime/helpers/get");

var _inherits = require("/opt/build/repo/web/node_modules/@babel/runtime/helpers/inherits");

var _possibleConstructorReturn = require("/opt/build/repo/web/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/opt/build/repo/web/node_modules/@babel/runtime/helpers/getPrototypeOf");

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

var BitField = require('bitfield').default;

var debug = require('debug')('webtorrent:webconn');

var get = require('simple-get');

var sha1 = require('simple-sha1');

var Wire = require('bittorrent-protocol');

var VERSION = require('../package.json').version;
/**
 * Converts requests for torrent blocks into http range requests.
 * @param {string} url web seed url
 * @param {Object} torrent
 */


var WebConn = /*#__PURE__*/function (_Wire) {
  "use strict";

  _inherits(WebConn, _Wire);

  var _super = _createSuper(WebConn);

  function WebConn(url, torrent) {
    var _this;

    _classCallCheck(this, WebConn);

    _this = _super.call(this);
    _this.url = url;
    _this.webPeerId = sha1.sync(url);
    _this._torrent = torrent;

    _this._init();

    return _this;
  }

  _createClass(WebConn, [{
    key: "_init",
    value: function _init() {
      var _this2 = this;

      this.setKeepAlive(true);
      this.once('handshake', function (infoHash, peerId) {
        if (_this2.destroyed) return;

        _this2.handshake(infoHash, _this2.webPeerId);

        var numPieces = _this2._torrent.pieces.length;
        var bitfield = new BitField(numPieces);

        for (var i = 0; i <= numPieces; i++) {
          bitfield.set(i, true);
        }

        _this2.bitfield(bitfield);
      });
      this.once('interested', function () {
        debug('interested');

        _this2.unchoke();
      });
      this.on('uninterested', function () {
        debug('uninterested');
      });
      this.on('choke', function () {
        debug('choke');
      });
      this.on('unchoke', function () {
        debug('unchoke');
      });
      this.on('bitfield', function () {
        debug('bitfield');
      });
      this.on('request', function (pieceIndex, offset, length, callback) {
        debug('request pieceIndex=%d offset=%d length=%d', pieceIndex, offset, length);

        _this2.httpRequest(pieceIndex, offset, length, callback);
      });
    }
  }, {
    key: "httpRequest",
    value: function httpRequest(pieceIndex, offset, length, cb) {
      var _this3 = this;

      var pieceOffset = pieceIndex * this._torrent.pieceLength;
      var rangeStart = pieceOffset + offset;
      /* offset within whole torrent */

      var rangeEnd = rangeStart + length - 1; // Web seed URL format:
      // For single-file torrents, make HTTP range requests directly to the web seed URL
      // For multi-file torrents, add the torrent folder and file name to the URL

      var files = this._torrent.files;
      var requests;

      if (files.length <= 1) {
        requests = [{
          url: this.url,
          start: rangeStart,
          end: rangeEnd
        }];
      } else {
        var requestedFiles = files.filter(function (file) {
          return file.offset <= rangeEnd && file.offset + file.length > rangeStart;
        });

        if (requestedFiles.length < 1) {
          return cb(new Error('Could not find file corresponnding to web seed range request'));
        }

        requests = requestedFiles.map(function (requestedFile) {
          var fileEnd = requestedFile.offset + requestedFile.length - 1;
          var url = _this3.url + (_this3.url[_this3.url.length - 1] === '/' ? '' : '/') + requestedFile.path;
          return {
            url: url,
            fileOffsetInRange: Math.max(requestedFile.offset - rangeStart, 0),
            start: Math.max(rangeStart - requestedFile.offset, 0),
            end: Math.min(fileEnd, rangeEnd - requestedFile.offset)
          };
        });
      } // Now make all the HTTP requests we need in order to load this piece
      // Usually that's one requests, but sometimes it will be multiple
      // Send requests in parallel and wait for them all to come back


      var numRequestsSucceeded = 0;
      var hasError = false;
      var ret;

      if (requests.length > 1) {
        ret = Buffer.alloc(length);
      }

      requests.forEach(function (request) {
        var url = request.url;
        var start = request.start;
        var end = request.end;
        debug('Requesting url=%s pieceIndex=%d offset=%d length=%d start=%d end=%d', url, pieceIndex, offset, length, start, end);
        var opts = {
          url: url,
          method: 'GET',
          headers: {
            'user-agent': "WebTorrent/".concat(VERSION, " (https://webtorrent.io)"),
            range: "bytes=".concat(start, "-").concat(end)
          }
        };

        function onResponse(res, data) {
          if (res.statusCode < 200 || res.statusCode >= 300) {
            hasError = true;
            return cb(new Error("Unexpected HTTP status code ".concat(res.statusCode)));
          }

          debug('Got data of length %d', data.length);

          if (requests.length === 1) {
            // Common case: fetch piece in a single HTTP request, return directly
            cb(null, data);
          } else {
            // Rare case: reconstruct multiple HTTP requests across 2+ files into one
            // piece buffer
            data.copy(ret, request.fileOffsetInRange);

            if (++numRequestsSucceeded === requests.length) {
              cb(null, ret);
            }
          }
        }

        get.concat(opts, function (err, res, data) {
          if (hasError) return;

          if (err) {
            // Browsers allow HTTP redirects for simple cross-origin
            // requests but not for requests that require preflight.
            // Use a simple request to unravel any redirects and get the
            // final URL.  Retry the original request with the new URL if
            // it's different.
            //
            // This test is imperfect but it's simple and good for common
            // cases.  It catches all cross-origin cases but matches a few
            // same-origin cases too.
            if (typeof window === 'undefined' || url.startsWith("".concat(window.location.origin, "/"))) {
              hasError = true;
              return cb(err);
            }

            return get.head(url, function (errHead, res) {
              if (hasError) return;

              if (errHead) {
                hasError = true;
                return cb(errHead);
              }

              if (res.statusCode < 200 || res.statusCode >= 300) {
                hasError = true;
                return cb(new Error("Unexpected HTTP status code ".concat(res.statusCode)));
              }

              if (res.url === url) {
                hasError = true;
                return cb(err);
              }

              opts.url = res.url;
              get.concat(opts, function (err, res, data) {
                if (hasError) return;

                if (err) {
                  hasError = true;
                  return cb(err);
                }

                onResponse(res, data);
              });
            });
          }

          onResponse(res, data);
        });
      });
    }
  }, {
    key: "destroy",
    value: function destroy() {
      _get(_getPrototypeOf(WebConn.prototype), "destroy", this).call(this);

      this._torrent = null;
    }
  }]);

  return WebConn;
}(Wire);

module.exports = WebConn;